import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';

export const VerticalTabComponent = ({ data = [], label = '', currentItem, handleClick }) => {
  const { genKey } = CCMClientSettingsConfig;
  const [tabItem, setTabItem] = useState(currentItem);

  return (
    <div className={classNames('mr-3', styles.verticalTabContainer)}>
      <ul>
        <li className={classNames(styles.item_header_label)}>{label}</li>
        {data.map(item => {
          const key = genKey(item.id);
          const isItemSelected = item.id === currentItem || item.id === tabItem;

          return (
            <li key={`${key}-li`} className={classNames(styles.item_li)}>
              <button
                key={`${key}-btn`}
                id={`configure_${key}`}
                className={classNames(styles.configure_item_btn, {
                  [styles.item_selected]: isItemSelected,
                  [styles.inactive]: !item.is_active && !isItemSelected
                })}
                onClick={() => {
                  setTabItem(item);
                  handleClick(item);
                }}
              >
                {item.name}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

VerticalTabComponent.propTypes = {
  data: PropTypes.array,
  label: PropTypes.string,
  currentItem: PropTypes.string,
  handleClick: PropTypes.func
};
